<template>
    <div v-if="readonly" class="password-input readonly">
        <div class="readonly-text">{{value}}</div>
    </div>
    <div v-else class="password-input" :class="{'validate-error':!validateResult}">
        <input :name="options.field" v-model="value" :type="type" placeholder="请输入密码"  autocomplete="off" />
        <div class="pw-icon" @click="changeType" >
            <showPasswordImg :width="'12px'" :height="'12px'" :color="'#999'" v-if="this.type == 'password'"  />
            <hidePasswordImg :width="'12px'" :height="'12px'" :color="'#999'" v-else/>
        </div>
    </div>
</template>
<script>
export default {
    props: ["options", "propValue", "rowIndex"],

    data() {
        return {
            validateResult: true,
            readonly: void 0,
            field: void 0,
            value: void 0,
            type: "password",
        };
    },

    created() {
        Object.assign(this, this.options);
        this.value = this.propValue;
    },

    watch: {
        value() {
            this.$emit("change", this.options.field, this.value, this.rowIndex);
        },
        propValue(val) {
            this.value = val;
        }
    },

    methods: {
        focusHandle() {
            this.$emit("focus", this.options.field, this.value, this.rowIndex);
        },

        changeType() {
            if (this.type == "password") {
                this.type = "text";
            } else {
                this.type = "password";
            }
        }
    }
};
</script>

<style>
.password-input {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
    position: relative;
}

.password-input.readonly {
    color: #666;
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    align-items: center;
}

.password-input input,
.password-input .readonly-text {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    height: 100%;
}

.password-input .readonly-text {
    background-color: #f4f4f4;
    color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
}

.password-input.validate-error input {
    border-color: #ff6e6e;
}

.password-input input:focus {
    border: 1px solid #4784ff;
}

.password-input .pw-icon {
    position: absolute;
    top: 0;
    right: 8px;
    margin: auto;
    width: 12px;
    cursor: pointer;
}

.password-input .pw-icon svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

</style>

